import { startApp } from "mainz";
import { app } from "./app.ts";

startApp(app, {
  mount: "#app",
});
